import { paymentStatus } from '../../../../utils/payment-status';
import { orderType } from '../../../../utils/order-type';
import { fileState } from '../../../../utils/file-state';

export function getFileStates({
    runningFileStateText,
    suspendedFileStateText,
    inOptionFileStateText,
    inReservationFileStateText,
    optionReservFileStateText,
    confirmedFileStateText,
    soldFileStateText,
    notSoldFileStateText,
    partSoldFileStateText,
    canceledFileStateText,
    abandonedFileStateText,
    techErrorFileStateText,
}) {
    const fileStates = {};

    fileStates[fileState.RUNNING] = runningFileStateText;
    fileStates[fileState.SUSPENDED] = suspendedFileStateText;
    fileStates[fileState.IN_OPTION] = inOptionFileStateText;
    fileStates[fileState.IN_RESERVATION] = inReservationFileStateText;
    fileStates[fileState.OPTION_RESERV] = optionReservFileStateText;
    fileStates[fileState.CONFIRMED] = confirmedFileStateText;
    fileStates[fileState.SOLD] = soldFileStateText;
    fileStates[fileState.NOT_SOLD] = notSoldFileStateText;
    fileStates[fileState.PART_SOLD] = partSoldFileStateText;
    fileStates[fileState.CANCELED] = canceledFileStateText;
    fileStates[fileState.ABANDONED] = abandonedFileStateText;
    fileStates[fileState.TECH_ERROR] = techErrorFileStateText;

    return fileStates;
}

export function getPaymentStatuses({
    waitingPaymentStatusText,
    inProgressPaymentStatusText,
    authorizedPaymentStatusText,
    paidPaymentStatusText,
    cancelledByUserPaymentStatusText,
    failedPaymentStatusText,
    abandonedPaymentStatusText,
    waitingManualValidationPaymentStatusText,
    failedRejectedPaymentStatusText
}) {
    const paymentStatuses = {};
    paymentStatuses[paymentStatus.WAITING] = waitingPaymentStatusText;
    paymentStatuses[paymentStatus.IN_PROGRESS] = inProgressPaymentStatusText;
    paymentStatuses[paymentStatus.AUTHORIZED] = authorizedPaymentStatusText;
    paymentStatuses[paymentStatus.PAID] = paidPaymentStatusText;
    paymentStatuses[paymentStatus.CANCELLED_BY_USER] = cancelledByUserPaymentStatusText;
    paymentStatuses[paymentStatus.FAILED] = failedPaymentStatusText;
    paymentStatuses[paymentStatus.ABANDONED] = abandonedPaymentStatusText;
    paymentStatuses[paymentStatus.WAITING_MANUAL_VALIDATION] = waitingManualValidationPaymentStatusText;
    paymentStatuses[paymentStatus.FAILED_REJECTED] = failedRejectedPaymentStatusText;

    return paymentStatuses;
}

export function getOrderTypes({
    saleOrderTypeText,
    refundClientOrderTypeText,
    refundOrganizationOrderTypeText,
    exchangeOrganizationOrderTypeText,
    exchangeClientOrderTypeText,
    reservationOrderTypeText,
    renewalOrderTypeText,
    optionOrderTypeText,
    reservationFreeingOrderTypeText,
    optionFreeingOrderTypeText,
    stTransferOrderTypeText
}) {
    const orderTypes = {};
    orderTypes[orderType.SALE] = saleOrderTypeText;
    orderTypes[orderType.REFUND_CLIENT] = refundClientOrderTypeText;
    orderTypes[orderType.REFUND_ORGANIZATION] = refundOrganizationOrderTypeText;
    orderTypes[orderType.EXCHANGE_ORGANIZATION] = exchangeOrganizationOrderTypeText;
    orderTypes[orderType.EXCHANGE_CLIENT] = exchangeClientOrderTypeText;
    orderTypes[orderType.RESERVATION] = reservationOrderTypeText;
    orderTypes[orderType.RENEWAL] = renewalOrderTypeText;
    orderTypes[orderType.OPTION] = optionOrderTypeText;
    orderTypes[orderType.RESERVATION_FREEING] = reservationFreeingOrderTypeText;
    orderTypes[orderType.OPTION_FREEING] = optionFreeingOrderTypeText;
    orderTypes[orderType.ST_TRANSFER] = stTransferOrderTypeText;

    return orderTypes;
}

export function getActionOrderTypes({
    saleActionOrderTypeText,
    refundClientActionOrderTypeText,
    refundOrganizationActionOrderTypeText,
    exchangeOrganizationActionOrderTypeText,
    exchangeClientActionOrderTypeText,
    reservationActionOrderTypeText,
    renewalActionOrderTypeText,
    optionActionOrderTypeText,
    reservationFreeingActionOrderTypeText,
    optionFreeingActionOrderTypeText,
    stTransferActionOrderTypeText
}) {
    const actionOrderTypes = {};
    actionOrderTypes[orderType.SALE] = saleActionOrderTypeText;
    actionOrderTypes[orderType.REFUND_CLIENT] = refundClientActionOrderTypeText;
    actionOrderTypes[orderType.REFUND_ORGANIZATION] = refundOrganizationActionOrderTypeText;
    actionOrderTypes[orderType.EXCHANGE_ORGANIZATION] = exchangeOrganizationActionOrderTypeText;
    actionOrderTypes[orderType.EXCHANGE_CLIENT] = exchangeClientActionOrderTypeText;
    actionOrderTypes[orderType.RESERVATION] = reservationActionOrderTypeText;
    actionOrderTypes[orderType.RENEWAL] = renewalActionOrderTypeText;
    actionOrderTypes[orderType.OPTION] = optionActionOrderTypeText;
    actionOrderTypes[orderType.RESERVATION_FREEING] = reservationFreeingActionOrderTypeText;
    actionOrderTypes[orderType.OPTION_FREEING] = optionFreeingActionOrderTypeText;
    actionOrderTypes[orderType.ST_TRANSFER] = stTransferActionOrderTypeText;

    return actionOrderTypes;
}
